import React from 'react'
// components
import TableForm from 'components/PageComponents/RiskTemplates/Edit/components/RiskTemplateFields/components/Table/components/TableForm'
// layers
import RiskFormProvider from './layers/BL'
// types
import { IField } from 'types/graphql'

interface Props {
  field: IField
}

const TableFormContainer: React.FC<Props> = ({ field }) => (
  <RiskFormProvider field={field}>
    <TableForm />
  </RiskFormProvider>
)

export default TableFormContainer
